import { combineReducers } from 'redux'

import {
  workflowsBuilderFormReducer,
  workflowsOwnerStatisticsReducer,
  workflowsModalReducer
} from 'features/workflows'
import passthrough from 'reducers/core/passthrough'

import eventTypes from './event_types'
import owner from './owner'
import ownerList from './owner_list'


export default combineReducers({
  builder: workflowsBuilderFormReducer,
  owner,
  owner_list: ownerList,
  ownerStatistics: workflowsOwnerStatisticsReducer,
  event_types: eventTypes,
  workflow_templates: passthrough,
  modals: workflowsModalReducer,
})
